import angular from 'angular';

/**
 * @param {import('angular').IFilterService} $filter
 * @param {import('angular').translate.ITranslateService} $translate
 * @param {any} Notification
 * @returns {any}
 */
const copyToClipboard = /* @ngInject */ (
	$filter,
	$translate,
	Notification,
) => (
	/** @type {string} */ valueToCopy,
	/** @type {boolean} */ showNotification,
	/** @type {Function} */ formatterFunction,
	/** @type {any} */ notificationOptions,
) => {
	if (!formatterFunction) {
		// eslint-disable-next-line no-param-reassign
		formatterFunction = (/** @type {any} */ v) => $filter('sprintf')($translate.instant('mf.has-been-copied'), v);
	}

	navigator.clipboard.writeText(valueToCopy).then(() => {
		if (showNotification) {
			Notification.info({
				title:   $translate.instant('common.info'),
				message: formatterFunction(valueToCopy),
				...notificationOptions,
			});
		}
		return true;
	}).catch((/** @type {any} */ error) => {
		Notification.error({
			title:   $translate.instant('error.title'),
			message: error,
		});
	});

	return true;
};

angular.module('app')
	.service('$copyToClipboard', copyToClipboard);
